import { commonSbEnv } from "./env.sb.common";

const env: Partial<typeof commonSbEnv> = {
  production: true,
  page: 'bursa-nivel-2',
  pageCode: 'sbbn2',
  meta: {
    siteTitle: 'Stiinta Banilor - curs de investitii eficiente pe bursa nivelul 2',
    ogSiteName: 'Stiinta Banilor',
    siteDescription: '',
    ogImageAlt: '',
    ogUrl: 'https://stiintabanilor.ro/cursuri/curs-investitii-eficiente-pe-bursa-nivelul-2/',
    ogImage: 'https://stiintabanilor.ro/cursuri/curs-investitii-eficiente-pe-bursa-nivelul-2/assets/images/bursa-nivel-2/cover-fb.png'
  }
};

export const environment = { ...commonSbEnv, ...env };
